import enumeration from "./enumeration";

const CartOperation = {
	Add: "ADD",
	Remove: "REMOVE",
};

export default enumeration(CartOperation);
